import { OrganizationManager } from '@copilot/data';
import { OrganizationActions } from '@copilot/common/store/actions/organization';
import { useStoreLoader } from '../common';

export const useOrganization = (id: string) => {
	if (!id) return;
	useStoreLoader(OrganizationActions.loadOrganization, () =>
		OrganizationManager.getOrganization(id)
	);
};
